import { createSlice } from '@reduxjs/toolkit';

const editEventInfoSlice = createSlice({
  name: 'editEventInfo',
  initialState: {
    editEvent: null,
  },
  reducers: {
    setEditEventInfo: (state, action) => {
      state.editEvent = action.payload;
    },
    clearEditEventInfo: (state) => {
      state.editEvent = null;
    },
  },
});

export const { setEditEventInfo, clearEditEventInfo } = editEventInfoSlice.actions;

export default editEventInfoSlice.reducer;
